import { render, staticRenderFns } from "./pricelist-tutorial.vue?vue&type=template&id=0dc0a3f2&"
import script from "./pricelist-tutorial.vue?vue&type=script&lang=js&"
export * from "./pricelist-tutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports